import type { ReferralEligibility } from './referral-eligibility.model';

export interface GenerateReferralEligibilityObjectOptions {
  readonly id?: number;
  readonly isInEligibleCountry?: boolean;
  readonly isEligibleUser?: boolean;
  readonly isEmailVerified?: boolean;
  readonly isPhoneVerified?: boolean;
}

export function generateReferralEligibilityObject({
  id = 1,
  isInEligibleCountry = true,
  isEligibleUser = true,
  isEmailVerified = false,
  isPhoneVerified = false,
}: GenerateReferralEligibilityObjectOptions): ReferralEligibility {
  return {
    id,
    isInEligibleCountry,
    isEligibleUser,
    isEmailVerified,
    isPhoneVerified,
  };
}
